import { pt } from "vuetify/locale";

export default {
    ...pt,

    "alert": "Atenção",
    "add": "Adicionar",
    "back": "Voltar",
    "cancel": "Cancelar",
    "clear": "Limpar",
    "close": "Fechar",
    "confirm": "Confirmar",
    "next": "Seguinte",
    "save": "Guardar",
    "send_email": "Enviar",
    "help_country_code": "Código País",
    "help_search_country": "Procure um país",
    "help_mobile_number": "Nr. Telemóvel",
    "help_example": "Exemplo",
    "earned": "Acumulou",
    "info": "Info",
    "ingredients": "Ingredientes",
    "info_nutritional": "Informação Nutricional",
    "remove": "Remover",
    "removeall": "Remover Todos",

    "campaigns": "Campanhas",
    "highlights": "Destaques",
    "home": "Home",
    "items": "Artigos",
    "map": "Mapa",
    "address": "Morada",
    "settings": "Definições",
    "store": "Loja",
    "stores": "Onde Estamos",
    "support": "Apoio",
    "user": "Perfil",
    "offers": "Ofertas",
    "qrcode": "QRCode",
    "transactions": "Movimentos",

    "generic_error": "Conteúdo não disponível de momento",
    "mandatory": "Obrigatório",
    "missing": "Faltam",
    "no_movements_to_display": "Ainda não existem movimentos registados",
    "phone_number": "Nr. Telemóvel",
    "points": "Pontos",
    "spent": "Gasto",
    "next_point": "próximo ponto",
    "qrcode_show_message": "Apresente este código na Loja",
    "stores_not_available": "Não há Lojas Disponíveis",
    "total": "Total",
    "thank_you": "Obrigado!",
    "transactions_detail": "Detalhe",
    "user_profile_updated_success": "Perfil Atualizado com Sucesso",
    "user_welcome": "Olá",

    "id_document": "Número",
    "id_document_type": "Doc. de Identificação",

    "profile": {
        "birth_date": "Data de Nascimento",
        "birth_date_required": "Data de Nascimento Obrigatória",
        "birth_date_minors": "Data de Nascimento inválida, os menores estão excluídos",
        "citizen_card_size": "Deve ter 12 dígitos",
        "communication_preferences": "Preferências Comunicação",
        "email_required": "E-mail Obrigatório",
        "email_invalid": "E-mail Inválido",
        "favourite_store": "Loja Favorita",
        "gender": "Género",
        "gender_male": "Masculino",
        "gender_female": "Feminino",
        "gender_other": "Outro",
        "gender_required": "Género Obrigatório",
        "id_document_required": "Nr. Documento de Identificação obrigatório",
        "id_document_type_empty": "Deve selecionar o tipo de documento",
        "identity_card_size": "Deve ter 9 dígitos",
        "name": "Nome",
        "name_invalid": "Nome deve ter no máximo 20 caracteres",
        "name_invalid_two_names": "Primeiro e Último Nome",
        "name_required": "Nome Obrigatório",
        "number_invalid": "Número Inválido",
        "passport_size": "Deve ter 8 dígitos",
        "phone_number_required": "Nr. Telemóvel é Obrigatório",
        "phone_nine_digits": "Nr. Telemóvel deve ter 9 dígitos",
        "tax_number": "NIF",
        "tax_number_nine_digits": "NIF deve ter 9 dígitos",
        "tax_number_invalid": "NIF Inválido",
    },

    "gdpr_agreement": {
        "agreement_mandatory": "Para prosseguir deve aceitar as definições de privacidade.",
        "agreement_communication_means_mandatory": "Para prosseguir deve aceitar os canais de comunicação.",
        "gdpr_agreement": "Termos e Condições",
        "gdpr_agreement_accept": "Li e aceito os Termos e Condições, bem como a Protecção de Dados Pessoais.",
        "gdpr_agreement_agree": "Concordo",
        "gdpr_agreement_disagree": "Não Concordo",
        "program_terms_policy": "Condições Gerais Programa de Fidelização",
        "terms_policy": "Termos, Condições e Políticas de Privacidade",
        "gdpr_agreement_revoke": "Consentimento de registo dos dados pessoais revogado com sucesso. Os seus dados serão apagados.",
    },

    "authentication": {
        "login_error": "Não foi possível validar o utilizador e código indicados. Pfv tente novamente.",
        "end_session": "Sessão Terminada",
        "login_step_user_title": "Introduza o seu número de telemóvel",
        "login_step_user_subtitle": "Caso ainda não esteja registado iremos enviar-lhe uma SMS com uma password provisória para completar o seu registo.",
        "login_step_password_title": "Introduza a sua password",
        "login_step_newuser_password_subtitle": "Verifique a password na SMS que lhe foi enviada. Esta password é necessária para se autenticar novamente. Pode alterá-la no seu perfil após completar o seu registo.",
        "logout": "Logout",
        "new_register": "Novo Registo",
        "new_user":"Novo Utilizador?",
        "register_now":"Registar Agora",
        "password": "Password",
        "password_change": "Alterar Password",
        "password_old": "Password Atual",
        "password_new": "Nova Password",
        "password_new_success_sent": "Nova Password enviada para o seu telemóvel",
        "password_bigger_than8": "Deve ter pelo menos 8 caracteres;",
        "password_bigger_than10": "Deve ter pelo menos 10 caracteres;",
        "password_lower_case": "Deve incluir uma minúscula;",
        "password_one_number": "Deve incluir um dígito.",
        "password_special_char": "Deve incluir um caracter especial.",
        "password_upper_case": "Deve incluir uma maiúscula;",
        "password_recover": "Enviar Nova Password",
        "password_required": "Password Obrigatória",
        "username_nine_digits": "Nr. Telemóvel deve ter 9 dígitos",
        "phone_number_invalid": "Nr. Telemóvel Inválido",
        "password_change_success": "Password alterada com Sucesso"
    },

    "vouchers": {
        "vouchers": "Vales",
        "voucher_due_date": "Validade",
        "voucher_available_at": "Válido Em",
        "voucher_emitted": "Vale Emitido",
        "voucher_offers": "Vales & Ofertas",
        "voucher_rescued": "Vale Resgatado",
    },

    "shop": {
        "shop_cart": "Carrinho de Compras",
        "shop_cart_pay": "Pagamento",
        "shop_cart_checkout": "Prosseguir",
        "shop_cart_submit": "Finalizar",
        "shop_cart_items": "Artigos no Carrinho",
        "shop_cart_empty": "O carrinho de compras está vazio",
        "shop_cart_items_unavailable": "Alguns artigos do carrinho estão indisponíveis.",
        "shop_item_added_to_cart": "Artigo adicionado ao carrinho com sucesso",
        "shop_item_remove_from_cart": "Artigo removido do carrinho com sucesso",
        "shop_item_stock": "Stock Disponível",
        "shop_item_nostock": "Stock Indisponível",
        "order_successfully_submited": "Encomenda registada com sucesso",
        "buy": "Comprar",
        "payment_method": "Método de Pagamento",
        "shipping_costs": "Custos de Envio",
        "shipping_method": "Método de Envio",
        "shipping_location": "Local de recolha",
        "my_orders": "As Minhas Encomendas",
        "catalog": "Loja",
        "order_resume_comments": "Comentários",
        "order_resume_choose_date": "Escolher Data",
        "delivery_options": "Opções de Entrega",
        "delivery_not_available": "Opções de Entrega Indisponíveis",
        "order_resume": "Confirmação da Encomenda",
        "order_pay": "Pagamento",
        "order_payment_entity": "Entidade",
        "order_payment_reference": "Referência",
        "order_payment_value": "Valor",
        "order_payment_success": "Pagamento Verificado com Sucesso",
        "order_payment_pending": "A Aguardar Validação do Pagamento",
        "order_payment_error": "Não foi possível validar o Pagamento",
        "order_complete": "Encomenda Finalizada com Sucesso!",
        "exceeded_daily_orders": "Número máximo de Encomendas Diárias excedido",
        "item_details_view": "Ver Detalhes",
        "item_define_menu": "O Meu Menu",
        "item_define_menu_extra": "Opções",
        "remember_orders_in_progress": "Verifique o Estado das suas Encomendas",
        "remember_shop_cart": "O Carrinho de Compras está à sua espera",
        "promo_valid_until": "Promoção válida até",
    },

    "id_document_types": {
        "citizen_card": "Cartão de Cidadão",
        "identity_card": "Bilhete de Identidade",
        "passport": "Passaporte",
        "residence_permit": "Autorização de Residência",
    },

    "qr_scanner": {
        "scan_qr_code": "Ler Código QR",
        "camera_denied": "O acesso à câmara foi negado. Por favor, permita o acesso.",
        "camera_not_found": "Nenhuma câmara encontrada neste dispositivo.",
        "camera_in_use": "A câmara já está a ser utilizada por outra aplicação.",
        "camera_not_supported": "A câmara não é suportada neste dispositivo.",
        "camera_error": "Erro na câmara: ",
        "scanned_document": "Documento Lido",
        "document_number": "Número do Documento",
        "date": "Data",
        "total": "Total",
        "qr_code_data": "Dados do Código QR",
        "parse_error": "Não foi possível interpretar o formato ATCUD. Dados originais:",
        "no_data": "Nenhum dado de código QR recebido.",
        "add_purchase": "Adicionar Compra",
        "purchase_added": "Compra adicionada com sucesso",
        "purchase_error": "Ocorreu um erro ao adicionar a compra",
    }
}